module.exports={
    CHAINID:56,
    TOKEN_ADDRESS:"0x1eF72a1DF5e4d165F84fc43B20D56cAA7DaD46e1",
    MLM_ADDRESS:"0x3B19c6f753c7bB08C7e10884A773290CB690800B",
    DEFAULT_REF:"0x90166A0A5a79afb489540f6664d0Fde3B9c5c9EB",
    ANNUAL_APY:24,
    HALF_YEAR_APY:10,
}